import { getTabElementKey } from 'designer/component/container/tab/TabHelper'

export const getRendererTagname = (element = {}) => {
  let { tagname, convertType, scope, id, name } = element

  if (tagname) return tagname
  if (convertType) return convertType

  if (scope) {
    let scopeList = scope.replace('#/', '').split('/').filter(Boolean)
    let scopeTagname = scopeList.pop()
    if (scopeTagname) return scopeTagname
  }

  if (id === 'customTable' || name === 'customTable') return 'customTable'
  if (id === 'table' || name === 'table') return 'table'

  if (element.tableColumn || element.tableAction || element.loadData) {
    return 'table'
  }

  return id || name
}

export const getElementRendererList = (element) => {
  let elements = [element]
  let children = element?.elements || []

  children.forEach((child) => {
    elements = [...elements, ...getElementRendererList(child)]
  })

  return elements
}

export const getActiveTabElements = (elements = [], activeTab) => {
  let activeTabKey =
    activeTab || (elements.length > 0 ? getTabElementKey(elements[0]) : '')
  let foundTab = elements.filter(
    (element, index) => getTabElementKey(element, index) === activeTabKey
  )

  return foundTab.reduce((result, element) => {
    return [...result, ...getElementRendererList(element)]
  }, [])
}
